var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStacks24Dp434343Fill0Wght400Grad0Opsz24 = function SvgStacks24Dp434343Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#434343",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-400 40-640l440-240 440 240zm0 160L63-467l84-46 333 182 333-182 84 46zm0 160L63-307l84-46 333 182 333-182 84 46zm0-411 273-149-273-149-273 149zm0-149"
  })));
};
export default SvgStacks24Dp434343Fill0Wght400Grad0Opsz24;